import * as React from "react";
import Styled from "styled-components/macro";

const Errors = Styled.div``;

const Error = Styled.div`
  display: inline-block;
  padding: 0.0675rem 0.5rem 0rem 0.5rem;
  margin-top: 0.5rem;
  line-height: 1.5;
  font-size: 1.25rem;
  font-weight: 600;
  background: ${(props) => props.theme.colors.danger};
  color: ${(props) => props.theme.colors.white};
  border-radius: 0.25rem;
`;

const FormErrors = (props) => {
  const { errors = [] } = props;

  if (errors.length === 0) {
    return null;
  }

  return (
    <Errors>
      {errors.map((error) => (
        <Error key={error} data-selector="error">
          {error}
        </Error>
      ))}
    </Errors>
  );
};

export default FormErrors;
